import React from 'react'
import { Slot } from '@radix-ui/react-slot'

import classNames from 'classnames'

import styles from './SymbiosisButton.pcss'

export type SymbiosisButtonVariant = 'white' | 'black' | 'green'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	variant?: SymbiosisButtonVariant
	// Render the single child (e.g. a link) with the button styles
	asChild?: boolean
}

export const SymbiosisButton = React.forwardRef(function Button(
	{ asChild, className, variant = 'black', disabled, ...props }: Props,
	ref: React.ForwardedRef<HTMLButtonElement>
): JSX.Element {
	const Component = asChild ? Slot : 'button'

	const containerClassNames: (string | undefined)[] = []
	if (variant === 'black') {
		containerClassNames.push(styles.black)
	} else if (variant === 'white') {
		containerClassNames.push(styles.white)
	} else {
		containerClassNames.push(styles.green)
	}

	if (disabled) {
		containerClassNames.push(styles.disabled)
	}

	return (
		<Component
			className={classNames(
				styles.container,
				...containerClassNames,
				className
			)}
			ref={ref}
			disabled={disabled}
			{...props}
		/>
	)
})
